import { BluPayApiError } from "../api/client";

/**
 * Puts the backend's per-field messages onto a react-hook-form form.
 *
 * `fieldMap` renames API fields to form fields where they differ
 * (`{ full_name: "firstName" }`). Returns whether any field was set.
 */
export function applyFieldErrors(error, setError, fieldMap = {}) {
  if (!(error instanceof BluPayApiError) || !error.fields) {
    return false;
  }

  const entries = Object.entries(error.fields);

  entries.forEach(([name, message]) => {
    setError(fieldMap[name] || name, { type: "server", message });
  });

  return entries.length > 0;
}
